import { serviceMaker, methods, api } from "@/http/index.js";

export const gethardwaremappingData = () =>
  serviceMaker(`/hardwaremapping`, methods.GET, api.NGB);
export const gethardwareMappingTemplate = () =>
  serviceMaker(`/hardwaremapping/template`, methods.GET, api.NGB);
export const createHardwareMapping = (data) =>
  serviceMaker(`/hardwaremapping`, methods.POST, api.NGB, data);
export const editHardwareMappingData = (id) =>
  serviceMaker(`/hardwaremapping/${id}?template=true`, methods.GET, api.NGB);
export const updateHardwareMapping = (id, data) =>
  serviceMaker(`/hardwaremapping/${id}`, methods.PUT, api.NGB, data);
export const getprovisioningData = () =>
  serviceMaker(`/provisioning`, methods.GET, api.NGB);
export const getProvisioningTemplate = () =>
  serviceMaker(`/provisioning/template`, methods.GET, api.NGB);
export const createProvisioning = (data) =>
  serviceMaker(`/provisioning`, methods.POST, api.NGB, data);
export const dataByIdProvisioning = (id) =>
  serviceMaker(`/provisioning/${id}`, methods.GET, api.NGB);
export const updateProvisioning = (id, data) =>
  serviceMaker(`/provisioning/${id}`, methods.PUT, api.NGB, data);
export const deleteProvisioning = (id) =>
  serviceMaker(`/provisioning/${id}`, methods.DELETE, api.NGB);
export const getprovisioningActionsData = () =>
  serviceMaker(`/provisioningactions`, methods.GET, api.NGB);
export const getnetworkelementData = () =>
  serviceMaker(`/networkelement?limit=14&offset=0`, methods.GET, api.NGB);
export const getNetworkElementTemplate = () =>
  serviceMaker(`/networkelement/template`, methods.GET, api.NGB);
export const createNetworkElement = (data) =>
  serviceMaker(`/networkelement`, methods.POST, api.NGB, data);
export const editNetworkElementData = (id) =>
  serviceMaker(`/networkelement/${id}?template=true`, methods.GET, api.NGB);
export const updateNetworkElement = (id, data) =>
  serviceMaker(`/networkelement/${id}`, methods.PUT, api.NGB, data);
export const deletenetworkElement = (id) =>
  serviceMaker(`/networkelement/${id}`, methods.DELETE, api.NGB);
export const updateprovisioningActions = (id, data) =>
  serviceMaker(`/provisioningactions/${id}`, methods.PUT, api.NGB, data);
